<template>
  <nav>
    <ul class="c-site-nav u-st2">
      <li class="c-site-nav__item">
        <router-link class="c-site-nav__link" :to="{ name: 'about' }">About us</router-link>
      </li>
      <li class="c-site-nav__item">
        <router-link class="c-site-nav__link" :to="{ name: 'projects' }">Projects</router-link>
      </li>
      <li class="c-site-nav__item">
        <router-link class="c-site-nav__link" :to="{ name: 'birds' }">Sponsored Birds</router-link>
      </li>
      <li class="c-site-nav__item">
        <router-link class="c-site-nav__link" :to="{ name: 'donate' }">Donate</router-link>
      </li>
      <li class="c-site-nav__item">
        <router-link class="c-site-nav__link" :to="{ name: 'news' }">News</router-link>
      </li>
      <li class="c-site-nav__item">
        <router-link class="c-site-nav__link" :to="{ name: 'contact' }">Contact</router-link>
      </li>
    </ul>
  </nav>
</template>

<script>
export default {
  name: 'SiteNav'
}
</script>



// WEBPACK FOOTER //
// src/components/SiteNav.vue